import MultiplePersons from "./SVG/multiplePersons.svg?react";

const MultiplePersonsIcon = () => {
  return <MultiplePersons />;
};

export default MultiplePersonsIcon;
